import {RoomImageMetadata, RoomTemplateImage} from '../../room/model';
import {ExtraModel} from './extra.model';
import {ExtraBasketModel} from './extra.basket.model';

const getCoverImage = (extra: ExtraModel | ExtraBasketModel) => {
  if (extra.pictures.length) {
    return extra.pictures[0].templates.find(t => t.name === RoomTemplateImage.Original);
  }

  return {} as RoomImageMetadata;
};

export const ExtraHelper = {getCoverImage};
